module.exports = __webpack_public_path__ + "img/assets/select/black-brush@2x.8790be0e9b6bd964d9c65d8e9e937bae.webp";